import Image from "gatsby-image";
import React from "react";
import OgImage from "../../../../assets/images/blog/article_16/og.png";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import {ArticlePhotos} from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();

  return {
    date:              "14.02.2022r",
    category:          "content marketing, strategia",
    title:             "Przepis na sukces, czyli co to jest strategia marketingowa",
    SEO_title:         "Przepis na sukces, czyli co to jest strategia marketingowa",
    description:
                       <>
                         Dlaczego na rynku istnieją marki, które od wielu lat znajdują się w czołówce zarówno pod względem popularności, jak i zysków? Coca Cola to lider wśród napojów bezalkoholowych. Apple to marka, której telefony są najczęściej kupowane. Google to najbardziej dochodowa firma, która od kilku lat zajmuje w rankingach miejsce na podium. Te marki to tylko przykłady. Co je łączy? Perfekcyjnie zaplanowane działania marketingowe.
                         <br/> <br/>
                         Każdy przedsiębiorca marzy o tym, aby jego marka przynosiła same zyski, cieszyła się popularnością wśród klientów, a do tego reprezentowała same etyczne wartości. Jednak nie każdy zdaje sobie sprawę, że wszystko to, co marka chce osiągnąć i wszystkie działania, które to umożliwią, trzeba zawrzeć w jej strategii!
                       </>,
    seo:               " Dlaczego na rynku istnieją marki, które od wielu lat znajdują się w czołówce zarówno pod względem popularności, jak i zysków? Coca Cola to lider wśród napojów bezalkoholowych. Apple to marka, której telefony są najczęściej kupowane.",
    slug:              "/blog/przepis-na-sukces-czyli-co-to-jest-strategia-marketingowa",
    image:             OgImage,
    authors:           [
      authors.MarzenaKawalerska,
    ],
    hero:              (
                         <Image
                           alt=""
                           objectPosition={"center"}
                           objectFit={"contain"}
                           fluid={images.hero.childImageSharp.fluid}
                         />
                       ),
    text:              {
      first:  {
        title: "Strategia marketingowa krok po kroku",
        text:  <>
                 Na początku wyjaśnijmy, co to dokładnie jest strategia marketingowa i na czym polega. Jest to <strong>proces, którego celem jest wypromowanie produktu lub usługi</strong> tak, by wyróżniła się wśród konkurencji. To zarówno praca analityczna, jak i kreatywna. To opracowanie sposobu komunikacji, odpowiedniego przekazu i kreacji produktów. A sukces marki jest możliwy przez realizację określonych działań i zasad postępowania.
               </>,
      },
      second: {
        title: "Dlaczego powstała Twoja marka?",
        text:  <>Pierwszym, a zarazem najważniejszym krokiem jest określenie celów oraz misji firmy. Zastanów się, co chcesz osiągnąć. Po co istnieje twoje przedsiębiorstwo? W celach marketingowych chodzi o konkrety. Stwierdzenie, że chcesz więcej zarabiać to dobry, ale mało precyzyjny cel. Natomiast dokładne określenie sumy, którą chcesz zobaczyć na swoim koncie, uściśli działania, które musisz podjąć. Z celu wynika misja, która jest wizją, wyraża dążenie do wyższych, bardziej ogólnych ideałów. Zarówno cel naszej działalności, jak i przyświecająca nam misja, muszą znaleźć zwolenników wśród naszych klientów, dlatego też kolejnym krokiem w opracowywaniu strategii jest określenie grupy docelowej.</>,
      },
      third:  {
        title: "Zmień odbiorców w klientów",
        text:  <>
                 Musisz wiedzieć, do kogo chcesz kierować komunikację swojej marki. Im bardziej ją zawęzisz, tym lepiej - ważne, by odbiorcy otrzymywali takie treści, jakich aktualnie potrzebują. Określając grupę docelową, należy uwzględnić dane demograficzne, miejsce zamieszkania, wykształcenie, życie zawodowe, status materialny czy poziom życia. Ponadto warto zastanowić się nad ich nastawieniem do życia, wyznawanymi poglądami, aspiracjami i marzeniami, priorytetami, problemami i obawami czy oczekiwaniami względem produktu lub usługi. W tym przypadku bardzo pomocne jest stworzenie persony, która odzwierciedla wymarzonego klienta.
               </>
      },
      fourth: {
        title: "Odpowiednie komunikaty w odpowiednim miejscu",
        text:  "Na podstawie informacji pochodzących od klientów należy dokonać wyboru kanałów dystrybucji treści - czy będzie to blog, media społecznościowe, a może kilka kanałów, w których będą one publikowane równolegle. Każdy kanał dystrybucji to przestrzeń, która łączy firmę z użytkownikami i odbiorcami komunikatów. Jest to sposób na bezpośrednie dotarcie do klienta, wiec wybór powinien być starannie przemyślany. Pisz artykuły, nagrywaj filmy czy podcasty, rób zdjęcia. Treści powinny odpowiadać potrzebom klientów i przez to oddziaływać na nich. Dostarcz swoim odbiorcom atrakcyjny content i zaangażuj ich!"
      },
      fifth:  {
        title: "Zastanów się, jakie masz możliwości i…",
        text:  "Przy prowadzeniu własnej działalności budżet marketingowy zawsze powinien znaleźć się na szczycie koniecznych wydatków. Przemyśl, na jakie działania pozwalają Twoje finanse. Sztuką nie jest się wybić, a utrzymać na rynku.",
      },
      sixth:  {
        title: "… działaj!",
        text:  <>
                 Przygotuj plan marketingowy - dla każdego rodzaju celów należy oszacować czas potrzebny na ich realizację. Konsekwentnie wdrażaj wszystkie opracowane działania i pomysły. W czasie planowania zadań zarezerwuj czas na ewentualne poprawki. Pamiętaj, że dobra strategia marketingowa powinna być aktualizowana czy dostosowywana do najnowszych realiów, trendów czy technologii w branży.
                 <br/><br/>
                 Opracowanie strategi marketingowej jest zajęciem czasochłonnym, ale pozwala dobrze przygotować się na wejście w interakcję z odbiorcami treści. Im lepiej poznamy klientów i im staranniej dobierzemy kanał komunikacji czy zaplanujemy harmonogram działań, tym większą szansę mamy na stworzenie pozytywnych relacji z potencjalnymi klientami.
                 <br/><br/>
                 Nie poddawaj się więc po dwóch tygodniach bezskutecznego promowania marki, nie panikuj i nie tnij budżetów w akcie desperacji. Daj sobie, agencji, z którą współpracujesz i klientom czas na rozruch.
                 <br/><br/>
                 Masz pytania? Chciałbyś zwiększyć sprzedaż swoich produktów lub usług? <a href="/kontakt/#formularz_kontaktowy">Odezwij się</a>, a my opracujemy dla Twojej firmy strategię marketingową!
               </>
      },
    },
    imagesWithCaption: {
      first: {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_1.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   438,
      },
    },
  };
};
